import { render, staticRenderFns } from "./ResourcesComponent.vue?vue&type=template&id=4025c050&scoped=true"
import script from "./ResourcesComponent.vue?vue&type=script&lang=js"
export * from "./ResourcesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025c050",
  null
  
)

export default component.exports